// ./src/utils/reportStats.js
import React from "react";
import { useAppContext } from "../context/appContext";
import { numberToMoney } from "./money";
import { useNavigate } from "react-router-dom";


function BaseStats({ data, title = "Base Statistics" }){

	const { loadMainRecords } = useAppContext();
  const navigate = useNavigate();
  
  const loadLargestJob = (data) => {
    loadMainRecords(data?.largestJob.jobId);
    navigate("../job-summary");
  };

  const totalQty = data?.quantity.reduce((a, c) => a + c, 0);
  const totalValue = data?.value.reduce((a, c) => a + c, 0);
  const maxValue = data?.largestJob.amount;
  const maxJobNum = data?.largestJob.jobNumber;
  const dataLength = data?.labels?.length;
  
  return totalQty > 0 && (
    <div className="form-row report-totals one-half">
      <br />
      <h3>{title}</h3>
      Total Quantity: {totalQty}
      <br />
      Average Quantity per Term: {(totalQty / dataLength).toFixed(1)}
      <br />
      Total Value: {numberToMoney(totalValue)}
      <br />
      Average Value per Term: {numberToMoney(totalValue / dataLength)}
      <br />
      Largest Job: {numberToMoney(maxValue)} -{" "}
      <a href="#" onClick={loadLargestJob}>
        {maxJobNum}
      </a>
      {/*
        <br />
        Total Profit/Expected Profit: (coming soon)
        <br />
        Average Profit: (coming soon)
        <br />
        Most Profitable Job: (coming soon)
        <br />
        Terms: {dataLength} ({dataLength - 1} complete terms and 1 partial)
      */}
    </div>
  );
}

export default BaseStats